import { render, staticRenderFns } from "./AddHouseRoom.vue?vue&type=template&id=74ca13a2&scoped=true"
import script from "./AddHouseRoom.vue?vue&type=script&lang=js"
export * from "./AddHouseRoom.vue?vue&type=script&lang=js"
import style0 from "./AddHouseRoom.vue?vue&type=style&index=0&id=74ca13a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca13a2",
  null
  
)

export default component.exports